<template>
    <div>

     <header class="memberHeader nav-down cf" v-show ="$store.getters.myModel">
        <div class="wrapper">
            <div class="topSec">

               <!-- <a href="/index"  class="backToHome">首頁</a> -->
                 <router-link to="/index"><a href="/index"  class="backToHome">首頁</a></router-link>

                      <!-- <a href="#0" class="nav_trigger">Menu<span></span><span></span><span></span><span></span></a> -->
                        <!-- <a href="index.html" class="backToHome">首頁</a> -->

                        <strong class="logo">
                           <router-link to="/index"><a href="/index" >
                                <img src="@/assets/images/logo.png" alt="一刻鯨選">
                            </a>
                           </router-link>
                        </strong>
           
                        <div class="tools">
                            <!--會員已登入-->
                            <div class="globalMember">
                                <button >
                                    <span class="photo"><img :src="userInfo.avatar"/></span>
                                </button>
                                
                            </div>
                            <!--會員已登入 end-->
                        </div>
                        
                    </div>
                </div>
            </header>

      <header class="bodyHeader nav-down cf" v-show ="($store.getters.myModel && windowWidth > 768) || !$store.getters.myModel">
            <!-- <div class="stickyAnchor"></div> -->
                 
            <div class="wrapper">
                <div class="topSec">
                    <a href="#0"  class="nav_trigger">Menu<span></span><span></span><span></span><span></span></a>
                    <!-- <a href="index.html" class="backToHome">首頁</a> -->
                    <strong class="logo">
                      <router-link to="/index">                        
                        <a href="">
                            <img src="@/assets/images/logo.png"  alt="一刻鯨選">
                        </a></router-link>
                    </strong>
                    

 
                    <div class="tools">
                        <div class="globalSearch">
                            <div id="sb-search" class="sb-search">
                                <!-- <form>
                                    <input class="sb-search-input" placeholder="輸入關鍵字..." type="text" value="" name="search" id="search">
                                    <input class="sb-search-submit" type="submit" value="">
                                    <span class="sb-icon-search"></span>
                                </form> -->
                            </div>
                        </div>
                        <!--會員功能規劃中，之後會再改-->
                      
                       <div class="globalMember">
                            <a class="unlogin" href="javascript:;" v-show="!isAuthenticated">登入</a>
                            <button @click="pushToProfile" v-show="isAuthenticated">
                                <span class="photo"><img :src="userInfo.avatar"/></span>
                                <span class="name">{{userInfo.nickname}}</span>
                            </button>
                            <div class="memList" v-show="isAuthenticated">
                                <nav v-show="isAuthenticated">
                                    <ul class="cf">

                                        <router-link @click.native="changeMyIndicator(index)" :key="index" v-for="(navigator, index) in myNavigators" :class="[{'current':navigator.isSelected}, navigator.class]" tag="li" :to="navigator.to"><a>{{navigator.title}}</a></router-link>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <!--會員功能規劃中，之後會再改 end-->
                    </div>
                    <ul class="socialMedia">
                        <li class="fb"><a href="https://www.facebook.com/jinfmnet/" target="_blank">Facebook粉絲團</a></li>
                        <li class="yt"><a href="https://www.youtube.com/channel/UChsuz3ui48kTwvuY059i2lA?disable_polymer=true" target="_blank">YouTube頻道</a></li>
                    </ul>
                </div>
               
                 <nav class="mainNav cf">
                    <ul class="cf">
                        <!--因為配合行動版要顯示的項目不一樣，每個項目li都有自己的class name-->
                        <router-link @click.native="changeIndicator(index)" :key="index" v-for="(navigator, index) in navigators" :class="[{'current':navigator.title == $store.state.breadcrumb[1].name}, navigator.class]" tag="li" :to="navigator.to"><a>{{navigator.title}}</a></router-link>
                    </ul>
                </nav>
                
                <!--行動版navigation-->

               <nav class="mainNav_mobile cf">
                    <div class="container">
                        <ul class="cf">
                            <li >
                              <router-link to="/story" @click.native="changeIndicator()"><a href="/story" @click="close()">品牌故事</a></router-link>
                            </li>
                            <!-- <li><a href="https://jinfm.net/blog/">部落格</a></li> -->
                            <li><router-link to="/help" @click.native="changeIndicator()"><a href="/help" @click="close()">常見問題</a></router-link></li>

                            
                            <li><router-link to="/contact" @click.native="changeIndicator()"><a href="/contact" @click="close()">聯絡我們</a></router-link></li>
                             <li >
                            <li><router-link to="/terms" @click.native="changeIndicator()"><a href="/terms" @click="close()">服務條款</a></router-link></li>
                            </li>
                            <li><a href="http://www.udngroup.com/members/udn_privacy" target="_blank">隱私權聲明</a></li>
                        </ul>
                        <ul class="socialMedia">
                            <li class="fb"><a href="https://www.facebook.com/jinfmnet/" target="_blank">Facebook粉絲團</a></li>
                            <li class="yt"><a href="https://www.youtube.com/channel/UChsuz3ui48kTwvuY059i2lA?disable_polymer=true" target="_blank">YouTube頻道</a></li>
                        </ul>
                        <!-- <ul class="language">
                            <li class="current"><a href="#">繁體中文</a></li>
                            <li><a href="#">簡体中文</a></li>
                        </ul> -->
                    </div>
                </nav> 

              
            <div class="promote_popup" v-show="isIOS">
                <div class="wrap">
                    <figure>
                             <router-link to="/member/coupon" ><img @click="closePoP()" src="@/assets/images/banner/popbanner_tibe.jpg"> </router-link>

                    </figure>
                </div>
            </div>
          
                <!--行動版navigation end-->
            </div>
      
                    <div class="login" >
                            <div class="loginWrap">
                                <div class="mode" >
                                    <div class="wrap">
         
                                            <strong class="logo_jin">
                                                <img src="@/assets/images/logo.png" alt="一刻鯨選">
                                            </strong> 

                                        <ul>
                                            <li class="login_udn"><button  @click="clearDatas"><span>udn會員登入</span></button></li>
                                            <li class="login_mobile"><button  @click="clearDatas"><span>手機號碼登入</span></button></li>
                                            <li class="login_facebook">
                                                <!-- <a href="#">使用Facebook登入</a> -->
                                                <button @click="socialMediaLoginTest('fb')"><span>Facebook登入</span></button>
                                            </li>
                                            <li class="login_google">
                                                <!-- <a href="#">使用Google登入</a> -->
                                                <button @click="socialMediaLoginTest('google')"><span>Google登入</span></button>
                                            </li>
                                        </ul>
                                        <p class="btmInfo">選擇上述任一方式，<br>表示您已經閱讀並同意一刻鯨選的<a href="/terms" target="_blank">【服務條款】</a></p>
                                    </div>
                                </div>
                                <div id="login_udn" class="signForm udn" >
                                    <article>
                                        <div class="wrap">
                                            
                                            <figure><img src="@/assets/images/logo_udn_s.png" alt="udn logo"><p>udn會員登入</p></figure>
                                           
                                            <label for="usernameudn" :class="[{'error': !emailValid },'inp']"><!--如果輸入錯誤 新增class "error"-->
                                                <input @blur="checkerEmail(udnAccount.email)" :disabled="validated == 1" type="text" id="usernameudn" v-model.number="udnAccount.email" placeholder=" ">
                                                <span class="label">請輸入帳號</span>
                                                <span class="border"></span>
                                                <span class="errorText">電子信箱格式錯誤</span><!--輸入錯誤時出現-->
                                            </label>
                                            <label for="passwordudn" :class="[{'error': isUdnLoginError },'inp']">
                                                <input  @keyup.enter="udnAccountValidation"  type="password" :disabled="validated == 1" v-model="udnAccount.pwd" id="passwordudn" placeholder=" ">
                                                <span  class="label">請輸入密碼</span>
                                                <span class="border"></span>
                                                <span class="errorText">登入失敗</span><!--輸入錯誤時出現-->

                                            </label>
                                            <button v-promise-btn  type="submit"   @click="udnAccountValidation" class="btnStyle_2" id="submit_login_udn">
                                                <span data-original-title="登入">登入</span>
                                            </button>
                                        
                                            <a class="backToMode" :disabled="validated == 1" href="javascript:;">其他方式登入</a>
                                        </div>
                                        
                                    </article>
                                </div>
                                <div id="login_mobile" class="signForm mobile">
                                    <article>
                                        <div class="wrap">
                                            
                                            <figure><img src="@/assets/images/logo_mobile.png" alt="mobile logo"><p>手機號碼登入</p></figure>
                                            
                                            <div class="phoneNumber cf">
                                                <div class="code">
                                                    <span>國碼</span>
                                                    <div class="selectStyle_1">
   
                                                      <!-- <rain-auto-complete-input  class="selectStyle_1" :items="[ 'eee','eee2ee']"></rain-auto-complete-input>  -->
                                                        <select v-model="CountryCode" aria-hidden="true" class="selectStyle_1">
                                                        
                                                              <option v-for="countryJson in countryJsons" v-bind:value="countryJson.code">
                                                                {{ countryJson.code }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ countryJson.name }} 
                                                              </option>
                                                       
                                                        </select>

                                                        
                                                    </div>
                                                </div>
                                                <div class="number">
                                                    <label for="mobileNum" :class="[{'error': !phoneValid },'inp']">
                                                        <input   v-model="phoneNumber"  @blur="checkPhone(phoneNumber)"   aria-label="請輸入手機號碼" type="tel" id="mobileNum" placeholder=" ">
                                                        <span  class="label">請輸入機號碼</span>
                                                        <span class="border"></span>
                                                        <span class="errorText">手機號碼輸入錯誤</span><!--輸入錯誤時出現-->
                                                    </label>
                                                </div>
                                            </div>

																						<div id="sign-in-button"></div>

                                            <button v-if="isPhoneLoginSuccess == false" :disabled="countDownFlag"  @click="firebaseLoginWith('eee','phone')" class="btnStyle_2 color1light" id="getNewcode">
                                             
                                                    <rain-counter @time-end="countDownFlag=false,isPhoneLoginSuccess = false" :endTime='end' v-if="countDownFlag"></rain-counter>
																							    	<span data-original-title="取得驗證碼" v-else>取得驗證碼</span><!--倒數60秒顯示的字「60 秒後即可重新方送驗證碼」-->


                                            </button>

                                              <button v-else :disabled="countDownFlag"  @click="firebaseLoginWith('eee','phone')" class="btnStyle_2 color1light disable" id="getNewcode">
                                             
                                                    <rain-counter @time-end="countDownFlag=false,isPhoneLoginSuccess = false" :endTime='end' v-if="countDownFlag"></rain-counter>
																							    	<span data-original-title="取得驗證碼" v-else>取得驗證碼</span><!--倒數60秒顯示的字「60 秒後即可重新方送驗證碼」-->


                                            </button>
																						<p></p>
                                            <label for="Verification" :class="[{'error': isPhoneVerificationCodeError },'inp']">
                                                <input  @keyup.enter="getUserDataInfoFromPhone"  type="tel" id="Verification"  v-model="validatedCode" placeholder=" ">
                                                <span class="label">請輸入驗證碼</span>
                                                <span class="border"></span>
                                                <span class="infoText">取得驗證碼後，請在60秒內輸入驗證碼</span>
                                                <span class="errorText">驗證碼輸入錯誤</span><!--輸入錯誤時出現-->
                                            </label>
                                            <button v-promise-btn @click="getUserDataInfoFromPhone" type="submit" class="btnStyle_2" id="submit_login_mobile">
                                                <span  data-original-title="登入">登入</span>
                                            </button>
                                            <a class="backToMode" :disabled="validated == 1" href="javascript:;">其他方式登入</a>
                                        </div>
                                    </article>
                                </div>

                            </div>
                        </div>
     
        </header>
       


    </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as firebase from "firebase";
// import "firebase/auth";

import AWS from "aws-sdk";
import { getPersonalData } from "@/assets/js/api/api.js";
import rainCounter from "@/components/widget/rainCounter";
import rainAutoCompleteInput from "@/components/widget/rainAutoCompleteInput";
import { emailChecker } from "@/assets/js/rainFunctions.js";

firebase.initializeApp({
  apiKey: "AIzaSyDs5ouDeD7aXBd8nM4mwkiwBXjgsZ0Lrn8",
  authDomain: "jinfm-1023a.firebaseapp.com",
  databaseURL: "https://jinfm-1023a.firebaseio.com",
  projectId: "jinfm-1023a",
  storageBucket: "jinfm-1023a.appspot.com",
  messagingSenderId: "243943699611"
});

AWS.config.region = "ap-northeast-1"; // 区域
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: "ap-northeast-1:63985611-aadb-4d6f-b653-2c4cbdd5bb94"
});

export default {
  components: {
    rainCounter,
    rainAutoCompleteInput
  },
  data() {
    return {
      app: "",
      imgSrc: "@/assets/images/logo.png",
      KeyId: "arn:aws:kms:ap-northeast-1:580691962331:alias/ear-app-Encrypt",
      udnAccount: {
        email: "",
        pwd: ""
      },
      end: new Date().getTime() + 60000,
      validated: 0,
      validatedCode: "", // phone validated code
      phoneNumber: "", // phone number,
      countryJsons:"",
      CountryCode:"+886",
      countDownFlag: false,
      emailValid: true,
      phoneValid: true,
      smsValid: false,
      isIOS: false,
      isUdnLoginError: false,
      isPhoneVerificationCodeError: false,//手機驗證碼是否錯誤
      isPhoneLoginSuccess:false, // 判斷手機登入是否錯誤
      windowWidth:window.innerWidth,
      data:'',
    };
  },

  
  created() {
    this.countryJsons =  require('@/assets/json/country_code.json')

   // localStorage.setItem("isIosMsgShow", "false");
    var u = navigator.userAgent;
  //  this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  
 
   // if(this.isIOS == true){
     //  this.isIOS = true;
      // if ( result ) {
      //     // the user clicked ok
      // } else {
      //     // the user clicked cancel or closed the confirm dialog.
      // }
  //  }
  
  },

  update(){
      this.getUser( ` ${localStorage.getItem('credentialToken')}`);
  },

  mounted() {
    

           //宣傳 popup banner
    $(".promote_popup .wrap" ).prepend( "<button class='closeBtn'><span>Close</span></button>" );
    $(".promote_popup" ).append( "<a class='overlay'></a>" );

    $('.promote_popup .closeBtn, .promote_popup .overlay').click(function(){
        $('.promote_popup').fadeOut();
        
    });

        $( ".mainNav_mobile" ).append( "<a href='#0' class='nav_trigger'>Menu<span></span><span></span><span></span><span></span></a>" );
        $('.nav_trigger').click(function(){
        $('.nav_trigger').toggleClass('open');
        $('.mainNav_mobile').fadeToggle( "slow", "linear" );
        $('body, .bodyWrapper').toggleClass('overflowhidden');
    });
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });

    })

  },
  computed: {
    
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "navigators",
      "userInfo",
      "myNavigators",
      "isAuthenticated"

      // ...
    ])
  },
  methods: {

    closePoP(){
        $('.promote_popup').fadeOut();

    },
  
   
    close(){
  $('.nav_trigger').toggleClass('open');
        $('.mainNav_mobile').fadeToggle( "slow", "linear" );
        $('body, .bodyWrapper').toggleClass('overflowhidden');
    },
    pushToProfile(){
     
      if (this.windowWidth < 768 ) {
        this.$router.push('/member/profile')
      }
    },
    clearDatas(){
      this.udnAccount = {
        email: "",
        pwd: ""
      }
      this.emailValid = true
      this.phoneValid = true
      this.isUdnLoginError = false
      this.isPhoneVerificationCodeError = false
      this.validated = 0 
      this.phoneNumber = ""
      this.validatedCode = ""

    },
    checkerEmail(email) {
      this.emailValid = emailChecker(email);

    },
     checkPhone(phoneNumber) {

       if(phoneNumber.length <=6){

         this.phoneValid = false;
       }else{
         this.phoneValid = true;
       }

    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch("authLogout").then(() => {
            this.$router.push("/");
             this.$store.commit('savePath', '/index')

          });
          localStorage.removeItem('user-info') 
          // $('#login_udn').fadeIn(200)

          // Sign-out successful.
        })
        .catch(function(error) {
          console.log(error);
          // An error happened.
        });
    },
    changeMyIndicator(index) {
      if (index == this.myNavigators.length - 1) {
        this.signOut();
        return;
      }
      this.myNavigators.forEach(v => {
        v.isSelected = false;
      });
      this.myNavigators[index].isSelected = true;
    },
    changeIndicator(index) {
      this.navigators.forEach(v => {
        v.isSelected = false;

      });
      this.navigators[index].isSelected = true;
    //   if(index == 0){
    //      $('.global_qrcode').css('opacity', '1');
    //  }else{
    //   $('.global_qrcode').css('opacity', '0');

    //  }
    },
    kmsEncrypt(params) {
      return new Promise((s, j) => {
        const kmsClient = new AWS.KMS(); // kmsTool
        kmsClient.encrypt(params, (err, data) => {
          if (err) j(err);
          else {
            const { CiphertextBlob } = data;

            s(CiphertextBlob);
          }
        });
      });
    },
    smsSignin() {
      return new Promise((s, j) => {
        window.confirmationResult
          .confirm(this.validatedCode)
          .then(result => {
            // User signed in successfully.
            var user = result.user;
            s(user);
          })
          .catch(error => {
            this.isPhoneVerificationCodeError =true;
            j(error);
            // User couldn't sign in (bad verification code?)
            // ...
          });
      });
    },
    kmsDecrypt(params) {
      return new Promise((s, j) => {
        const kmsClient = new AWS.KMS(); // kmsTool
        kmsClient.decrypt(params, (err, data) => {
          if (err) j(err);
          else {
            const { Plaintext } = data;
            let token = String.fromCharCode(...Plaintext);
            s(token);
          }
        });
      });
    },
    getUdnToken(params) {
      return new Promise((s, j) => {
        var lambda = new AWS.Lambda();
        lambda.invoke(params, function(err, data) {
              this.data = data;

          if (err) j(err);
          // an error occurred
          else {
            var res = data.Payload.replace(/"/g, "");

            if (res == "err") j("帳號密碼錯誤");
            s(res);
          }
        });
      });
    },
    async udnAccountValidation() {
      if (!this.emailValid || this.udnAccount.pwd.lenght < 4) return;

      try {
        // $(".closeBtn").attr("disabled", true);
        this.validated = 1;
        //  console.log(this.udnAccount);
        // let account = { email: "udn.device@gmail.com", pwd: "Mobile168" };
        let params = {
          KeyId: this.KeyId,
          Plaintext: JSON.stringify(this.udnAccount)
        };
        // 1.加密帳號密碼
        let res = await this.kmsEncrypt(params);

        // 2.轉 payload data to base 64
        var b64encoded = btoa(String.fromCharCode.apply(null, res));
        // console.log(b64encoded);
        let payload = {
          data: b64encoded
        };
        let udnParams = {
          FunctionName: "firebaseAdminCreateCustom",
          Payload: JSON.stringify(payload)
        };

        // 3.取得 UDN Token
        let udnToken = await this.getUdnToken(udnParams);
        // console.log(udnToken);

        // 4.轉 payload data to base 64
        let KmsParams = {
          CiphertextBlob: Buffer(this.base64ToArrayBuffer(udnToken))
        };

        // 5.解密 UDN Token
        let kmsUDNToken = await this.kmsDecrypt(KmsParams);

        // 6.取得 firebase Token
        let user = await this.firebaseLoginWith(kmsUDNToken, "udn");

        this.getUdnUserFromFirebaseUser(user);
      } catch (err) {
        this.isUdnLoginError = true;
        // console.log(err);
        this.validated = 0;
      }
    },
    firebaseLoginWith(params, type) {
      return new Promise((s, j) => {
        switch (type) {
          case "udn":
            firebase
              .auth()
              .signInWithCustomToken(params)
              .then(v => {
                let user = firebase.auth().currentUser;
                s(user);
              })
              .catch(function(error) {

                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                j(errorMessage);
              });

            break;
          case "phone":
            // window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
            //   "sign-in-button"
            // );
            window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
              "sign-in-button",
              {
                size: "invisible",
                callback: function(response) {
                  // reCAPTCHA solved, allow signInWithPhoneNumber.
                  // alert("onSignInSubmit");
                  // onSignInSubmit();
                }
              }
            );
            firebase.auth().settings.appVerificationDisabledForTesting = true;
            var appVerifier = window.recaptchaVerifier;
            let useNumber = this.CountryCode + this.phoneNumber
            firebase
              .auth()
              .signInWithPhoneNumber(useNumber, appVerifier)
              .then((confirmationResult) => {
                this.countDownFlag = true;
                this.end = new Date().getTime() + 60000;
                window.confirmationResult = confirmationResult;
                 this.isPhoneLoginSuccess = true;

              })
              .catch(error => {

                 window.recaptchaVerifier.render().then(widgetId => {
                  grecaptcha.reset(widgetId);
                });
              });

            break;
          case "fb":
          case "google":
            firebase
              .auth()
              .signInWithPopup(params)
              .then(result => {
                let user = result.user;
                s(user);
              })
              .catch(error => {
                console.log("signInWithPopup-error");
                var errorMessage = error.message;
                j(error);
              });

            break;
          default:
            j(`type error : ${type}`);
            break;
        }
      });
    },
    async getUserDataInfoFromPhone() {
      let user = await this.smsSignin();
      this.getUdnUserFromFirebaseUser(user);
    },
    async getUdnUserFromFirebaseUser(user) {
      // let user = await this.smsSignin();
      // 7.Token to uint8Array

      params = {
        KeyId: this.KeyId,
        Plaintext: Buffer(this.toByArray(user.qa))
      };

      // 8.加密帳 firebase Token
      let token = await this.kmsEncrypt(params);
      // 9.轉 firebase Token to base 64
      var credentialToken = btoa(String.fromCharCode.apply(null, token));
     // console.log("log!!:"+credentialToken);
  
       localStorage.setItem("credentialToken", credentialToken);


      // 10.取得 個人加密資料
      let res = await getPersonalData(credentialToken);
      if (res.data) {
        let tempData = res.data.data;
        // 11.轉 個人加密資料 to base 64
        var params = {
          CiphertextBlob: this.base64ToArrayBuffer(tempData)
        };
        // 12.解密 個人加密資料
        let tempUserData = await this.kmsDecrypt(params);
        localStorage.setItem("user-info", tempUserData);
        let userInfo = JSON.parse(tempUserData);
        this.validated = 0;
        if (userInfo.avatar == null)
          userInfo.avatar = "@/assets/images/globalMember_icon.png";
    
        this.$store.commit("changeUserInfo", userInfo);



        $(".login").fadeOut();
        $(".signForm").fadeOut();
        $("body, .bodyWrapper").removeClass("overflowhidden");
        if(this.$store.state.savePath == ''){
          this.$store.state.savePath = '/index'
        }
         this.$router.push({ path: this.$store.state.savePath, params: {  } });
         this.$store.commit('savePath', '/index')

      }
    },

    toByArray(str) {
      // String to ByArray
      var utf8 = [];
      for (var i = 0; i < str.length; i++) {
        var charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) {
          utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
        } else if (charcode < 0xd800 || charcode >= 0xe000) {
          utf8.push(
            0xe0 | (charcode >> 12),
            0x80 | ((charcode >> 6) & 0x3f),
            0x80 | (charcode & 0x3f)
          );
        }
        // surrogate pair
        else {
          i++;
          charcode =
            0x10000 +
            (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
          utf8.push(
            0xf0 | (charcode >> 18),
            0x80 | ((charcode >> 12) & 0x3f),
            0x80 | ((charcode >> 6) & 0x3f),
            0x80 | (charcode & 0x3f)
          );
        }
      }
      return utf8;
    },
    base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },
    async socialMediaLoginTest(type) {
      const kmsClient = new AWS.KMS(); // kmsTool
      let provider;
      switch (type) {
        case "fb":
          provider = new firebase.auth.FacebookAuthProvider();
          break;
        case "google":
          provider = new firebase.auth.GoogleAuthProvider();
          break;
        default:
          return;
          break;
      }

      let user = await this.firebaseLoginWith(provider, type);
      this.getUdnUserFromFirebaseUser(user);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/subViews/Header.vue